import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Dashboard from '../dashboard/dashboard'

function dashboardRoute() {
  return (
    <>
      <Routes>
        <Route path='/' element={<Dashboard/>}/>
      </Routes>
    </>
  )
}

export default dashboardRoute
